exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-box .box[data-v-07c52024] {\n  background: #FFF;\n  border-radius: 10px;\n  padding: 40px 10px;\n  margin: 20px 0px;\n  cursor: pointer;\n  -webkit-transition: all 0.5s ease-out;\n  transition: all 0.5s ease-out;\n}\n.social-box .box[data-v-07c52024]:hover {\n  -webkit-box-shadow: 0 0 6px #4183D7;\n          box-shadow: 0 0 6px #4183D7;\n}\n.social-box .box .box-text[data-v-07c52024] {\n  margin: 10px 0px;\n  font-size: 15px;\n  line-height: 30px;\n}\n.social-box .box .box-btn a[data-v-07c52024] {\n  text-decoration: none;\n  color: #4183D7;\n  font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-07c52024","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/recruting/RecrutingDetail.vue
// module id = 2356
// module chunks = 0